"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CascadingMenu_1 = __importDefault(require("@jbrowse/core/ui/CascadingMenu"));
const material_1 = require("@mui/material");
const mobx_react_1 = require("mobx-react");
const hooks_1 = require("material-ui-popup-state/hooks");
const CascadingMenuButton = (0, mobx_react_1.observer)(function CascadingMenuButton({ children, menuItems, ...rest }) {
    const popupState = (0, hooks_1.usePopupState)({
        popupId: 'viewMenu',
        variant: 'popover',
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.IconButton, { ...(0, hooks_1.bindTrigger)(popupState), ...rest, disabled: menuItems.length === 0 }, children),
        react_1.default.createElement(CascadingMenu_1.default, { ...(0, hooks_1.bindPopover)(popupState), onMenuItemClick: (_, callback) => callback(), menuItems: menuItems, popupState: popupState })));
});
exports.default = CascadingMenuButton;
